// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"fdf33231","141":"4c29ce4a","188":"399c5bbb","363":"bc238c6c","384":"008dce97","481":"9cb363c6","525":"120019e0","729":"d134852f","851":"0729cac9"}[chunkId] + ".chunk.js";
};